import { createRequest, HttpMethod } from 'ehs-react';
import { icModel } from 'generated-ts-common';

type MenuUser = icModel.saf.infrastructure.model.menu.MenuUser;

/**
 * An AJAX request to request the menu users.
 */
export const requestMenuUsers = createRequest<void, MenuUser[]>({
  operation: 'retrieveMenuUsers',
  method: HttpMethod.GET,
  returnsArray: true
});

interface SelectUserRequest {
  /** The selected menu user. */
  selectedMenuUser: MenuUser;
}
/**
 * An AJAX request to select a menu user.
 */
export const selectUser = createRequest<SelectUserRequest, string>({
  operation: 'handleMenuClick',
  method: HttpMethod.POST,
  returnsArray: false
});

interface CheckDocumentRequest {
  /** The portal name. */
  portalName: string | null;
}

/**
 * An AJAX call to determine if the help document exists.
 */
export const checkIfHelpDocumentExists = createRequest<
  CheckDocumentRequest,
  boolean
>({
  operation: 'checkIfHelpDocumentExists',
  method: HttpMethod.GET,
  returnsArray: false
});

export const doAssertionRefresh = createRequest<void, string>({
  operation: 'doAssertionRefresh',
  method: HttpMethod.GET,
  returnsArray: false
});
